// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3-jo4","label":"Category_label__18uf_","content":"Category_content__oIBqW","header":"Category_header__2bEHO","location":"Category_location__uGxkw"};